import { dateFormat } from 'app/appSettings'
import CustomDatePickerWithError from 'app/views/common-components/date-pickers/CustomDatePickerWithError'
import { isNil } from 'lodash'
import moment from 'moment'

/** Represents the condition item structure. */
interface ConditionItem {
  parameter?: string | null
}

/** Props for the ConditionDatePickerField component. */
interface ConditionDatePickerFieldProps {
  item: ConditionItem
  onChange: (value: string | null, keyboard?: string) => void
}

/**
 * A component for rendering a date picker field for a given condition.
 *
 * @param {ConditionDatePickerFieldProps} props - The properties for the component.
 * @returns {JSX.Element} A date picker field for managing condition dates.
 */

export default function ConditionDatePickerField ({
  item,
  onChange
}: ConditionDatePickerFieldProps): JSX.Element {
  return (
    <CustomDatePickerWithError
      inputVariant='outlined'
      fullWidth
      format={dateFormat}
      value={isNil(item?.parameter) ? null : moment.utc(item.parameter).format(dateFormat)}
      onChange={(e, keyboard) => onChange(e, keyboard)}
    />
  )
}
